import React, { useCallback, useEffect, useState } from 'react';
import { Button, Flex, Dialog, Box, Separator, IconButton, Text } from '@radix-ui/themes';
import { Cross1Icon } from '@radix-ui/react-icons';

import { instance } from 'api/axios.instance';
import { SelectBox } from '../form';
import './style.scss';

// 아젠다 작성 요청 모달
export function AgendaRequestDialog({ handleClick, projectStage }) {
  const [selectedAgenda, setSelectedAgenda] = useState('');
  const [selectedStage, setSelectedStage] = useState('');
  const [agendaList, setAgendaList] = useState([]);

  const getFilteredStageOptions = () => {
    if (!projectStage) {
      return [
        { value: '1단계', label: '1단계' },
        { value: '2단계', label: '2단계' },
        { value: '3단계', label: '3단계' },
        { value: '4단계', label: '4단계' }
      ];
    }

    const currentStageNum = parseInt(projectStage.replace('단계', ''));
    const allStages = [
      { value: '1단계', label: '1단계', num: 1 },
      { value: '2단계', label: '2단계', num: 2 },
      { value: '3단계', label: '3단계', num: 3 },
      { value: '4단계', label: '4단계', num: 4 }
    ];

    return allStages.filter(stage => stage.num >= currentStageNum);
  };

  const handleConfirm = () => {
    if (!selectedAgenda) {
      alert('아젠다를 선택해주세요.');
      return;
    }
    if (!selectedStage) {
      alert('아젠다 단계를 선택해주세요.');
      return;
    }
    handleClick({ agenda: selectedAgenda, stage: selectedStage });
  };

  const fetchList = useCallback(async () => {
    const response = await instance('/admin/agenda/active/list', {
      method: 'GET'
    });
    setAgendaList(
      response.data.data.map(agenda => ({
        value: agenda.code,
        label: agenda.name
      }))
    );
  }, []);

  useEffect(() => {
    fetchList();
  }, [fetchList]);

  return (
    <Dialog.Content maxWidth="480px" className="state-dialog">
      <Dialog.Title size="4">
        <Flex align="center" justify="between">
          <Box className="dialog-title">아젠다 작성 요청</Box>
          <Dialog.Close>
            <IconButton className="rt-variant-text close-btn">
              <Cross1Icon />
            </IconButton>
          </Dialog.Close>
        </Flex>
      </Dialog.Title>
      <Dialog.Description />
      <Separator size="4" mt="var(--space-5)" mb="var(--space-8)" />

      <Flex align="center" justify="between" gap="var(--space-1)" mb="var(--space-6)">
        <Text as="p" color="gray">
          아젠다 명
        </Text>
        <SelectBox
          placeholder="아젠다를 선택해주세요"
          value={selectedAgenda}
          options={agendaList}
          onChange={value => setSelectedAgenda(value)}
          className="dialog-select-box"
        />
      </Flex>

      <Flex align="center" justify="between" gap="var(--space-1)" mb="var(--space-6)">
        <Text as="p" color="gray">
          아젠다 단계
        </Text>
        <SelectBox
          placeholder="아젠다 단계를 선택해주세요"
          value={selectedStage}
          options={getFilteredStageOptions()}
          onChange={value => setSelectedStage(value)}
          className="dialog-select-box"
        />
      </Flex>

      <Flex gap="2" mt="var(--space-8)" justify="end">
        <Dialog.Close>
          <Button disabled={!selectedAgenda || !selectedStage} onClick={handleConfirm}>
            저장
          </Button>
        </Dialog.Close>
        <Dialog.Close>
          <Button variant="outline">취소</Button>
        </Dialog.Close>
      </Flex>
    </Dialog.Content>
  );
}
